module.exports = __webpack_public_path__ + "img/tramite.b41918b3.jpg";